module.exports = __webpack_public_path__ + "static/media/12UNCTAD15.268988f6.jpg";